__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-account-copy/v3_0_10/";